if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

var lastScrollTop = 0;

function verifyCorporateEmailSym(){

     // Function to send a POST request to the login endpoint
     const apiUrl = '/ajax/functions.php?operation=verifyCorporateEmail';

     const discountForm = document.getElementById('discountForm');
     const responseMessage = document.getElementById('response-message');
     const responseForm = document.getElementById('response-form');
     const apiKey = "Bearer nYt8zfF1XrYu2soDQ7tkrHOpFuRmLBJMzUfc4FOS"
     const recToken = document.querySelector( "[name=recToken]" ).value
         
     const url = document.URL
     if( url.indexOf( "zipscarwash.com" ) != "-1" && recToken == "" ) return;
 
     const formData = new FormData(discountForm);
 
     const requestOptions = {
         method: 'POST',
         body: formData,
         headers: {
             'Authorization': apiKey
         },
     };
 
     fetch( apiUrl, requestOptions)
         .then(response => {
             if (!response.ok) {
                 throw new Error('Network response was not ok');
             }
             return response.json();
         })
         .then((data) => {
             if (data.message == 'No matches found') {
                 responseMessage.innerHTML = "<div class='discount-quad__content'><h2>BEEP <span>BEEP!</span></h2><p>Your company isn’t included yet but we’re always expanding. Please complete the form below.</p></div>";
                 responseForm.classList.remove("hidden")
             } else{
                 if (!responseForm.classList.contains("hidden")) {
                     responseForm.classList.add("hidden")
                 }
                 responseMessage.innerHTML = `<div class='discount-quad__content'><h2>CONGRATS!</h2><p>Your Corporate Partner Discount is  ${data.partnership.promo}! We’ve captured your work email and will send you next steps shortly.</p></div>`;
                 
             }
         })
         .catch(error => {
         console.error('Error:', error);
         });

}

(function(){
    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

    const validateEmail = (email) => {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(String(email).toLowerCase());
    };

    document.addEventListener('DOMContentLoaded', function() {
        //UPDATE ZIPCODES
        if(window.location.pathname ==='/'){
            updateZipCodes();
        }

		// BURGER NAV
		document.querySelectorAll('.js-open-menu').forEach(btn => {
			btn.addEventListener('click', _ => {
				document.getElementById('burger-menu').classList.add('open');
			});
		});
		document.querySelectorAll('.js-close-menu').forEach(btn => {
			btn.addEventListener('click', () => {
				document.getElementById('burger-menu').classList.remove('open');
			});
		});

		//FAQ
		const elements = document.querySelectorAll('.faq__item');

		elements.forEach(element =>{
			let btn = element.querySelector('.faq__item-question');
			var answer = element.lastElementChild;
			var answers = document.querySelectorAll('.faq__item-answer');

            answer.style.setProperty('--offset', answer.scrollHeight + 'px');
			
			btn.addEventListener('click', ()=>{
				answers.forEach(ans =>{
					if(answer !== ans){
						ans.classList.add('hide');
						element.classList.add('active');
					}
				});
				
				answer.classList.toggle('hide');
			});
		});
	});

    $('.uwc-block__package-expand').click(function(e) {
		e.preventDefault();
        $(this).parent().toggleClass('expand');
    });
    $('.washes__package-expand').click(function(e) {
		e.preventDefault();
        $(this).parent().toggleClass('expand');
    });
    
    $('.sym-slides').slick({
        accessibility: false
    });

    $('.slider-overview_carousel').slick({
        dots: true,
        slidesToShow: 4,
        appendDots: '.slider-overview_dots',
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3
                }
            },
            {
                breakpoint: 900,
                settings: {
                    slidesToShow: 2
                }
            },
            {
                breakpoint: 640,
                settings: {
                    slidesToShow: 1,
                    fade: true
                }
            }
        ]
    });

    $('.modal-error__popup-close').click(function(e){
        e.preventDefault();
        $('.modal-error').addClass('hidden');
    });
    $('.uwc-block__inclusion-expand').click(function(e) {
		e.preventDefault();
        $(this).toggleClass('open');
        $(this).siblings('.uwc-block__inclusion-desc').slideToggle();
    });
    $('.expand-gallery').click(function(e) {
		e.preventDefault();
        $('.gallery-block__expand').slideDown();
        $('.gallery-block .btn').fadeOut();
    });

    var qString = document.location.href.split("?");
    var param = "?"+ qString[1];
    if (qString[1]){
        $("a").each(function() {
            var val = $(this).attr("href");
            //if(val != undefined && val.indexOf("#") == -1){
            //$(this).attr("href", val+param);
            //}
        });
    }
    
    $("#searchForm").on("submit",function(e){
        e.preventDefault();
        let pathname = window.location.pathname,
            redirect = $('#redirect').val();
        
        if(pathname=='/' || redirect != undefined)
                pathname = redirect;

        $(".zipsuccess").html("");
        $(".ziperror").html("");
        var data = {};
        let form = '#searchForm',
            zipcode = $(`${form} #zipcode`).val(),
            isNumber = (!isNaN(zipcode.substring(0,5)))?true:false,
            weirdZipCode = ['38008','38074'],
            state = ($(`${form} #state`).val() != undefined)?$(`${form} #state`).val():'',
            distance = 60;
            
        if(zipcode.length>5 && isNumber)
            zipcode = zipcode.substring(0,5);

        if(zipcode.length== 0 && state.length==0){
            alert('Please search by zip code');//Please search by zip code , city or state
            return false;
        }else if(zipcode.length== 0 && state.length>0){
            location.href = `${pathname}?state=${state}`;
        }else{
            if(weirdZipCode.includes(zipcode))
               distance = 60
            if(isNumber)
                location.href = `${pathname}?code=${zipcode}&distance=60`;
            else{
                //location.href = `${pathname}?state=${zipcode}&distance=${distance}`;
                alert('Please search by zip code');
                return false;
            }
        }

    });

    $( "#state" ).keyup(function(e) {
        e.preventDefault();
        const text = e.target.value,
              data = {};
        if(text.length>2){
            data.operation  = 'getCityAndState';
            data.text       = text;
            $.post(site_url + 'ajax/search.php', data, function(resp){
                if(resp.result =='success'){
                    if(!$('.list-city-state').hasClass('hidden')) $('.list-city-state').addClass('hidden');
                    $('.list-city-state').html('');
                    const states = Object.keys(resp.states);
                    if(states.length>0){
                        $('.list-city-state').removeClass('hidden');
                        Object.values(resp.states).forEach(state => {
                            $('.list-city-state').append(`<li class='item-state'>${state.name}</li>`);
                        });
                        $('.item-state').click(function(e){
                            e.preventDefault();
                            const item = $(this).html();
                            //$('.list-city-state').addClass('hidden');
                            $( "#state" ).val(item);
                            window.location.href = `${site_url}drive-through-car-wash-locations?state=${item}`;
                        });
                    }
                }
            }, 'json');
        }
    });
    $('.last-name input').attr('placeholder', 'Last');
    $('.first-name input').attr('placeholder', 'First');
    $('.locations__results-t-mobile').click(function(e){
        e.preventDefault();
        const location = $(this).data('postalcode'),
              storeAddress = $(this).data('address'),
              storeCode = $(this).data('storecode');
        $('#divResults').addClass('hidden');
        $('.step2').addClass('hidden');
        $('#divForm').removeClass('hidden');
        $('.step3').removeClass('hidden');
        $('#location_selected').html(storeAddress+'<span>'+location+'</span>');
        $('#location').val(storeCode);
        $("html, body").animate({ scrollTop: 0 }, "slow");
    });

    $('#formRedeem input').on("focus",function(e){
        const label = 'error_'+$(this).attr('name');
        $(`#${label}`).remove();
    });

    $("#email-signup .gdpr-wrap").prepend("<h2>ZIPS Alerts SMS Program</h2>");
    $("#email-signup #yes-signup-formemail-signup").prop( "checked", true );

    $("#formRedeem").on("submit",function(e){
        e.preventDefault();
        $('.error').remove();
        $('#redeem').attr('disabled',true);
        $('#redeem').html('Processing');
        $('#message').html('')
        let dataForm = $(this).serializeArray();

        $.ajax({
            url : 'https://uwcapp.zipscarwash.com/api/code',
            method: 'POST',
            data : dataForm,
            dataType: 'json',
            headers: {'Authorization': 'Bearer nYt8zfF1XrYu2soDQ7tkrHOpFuRmLBJMzUfc4FOS'},
            success : function(resp) {
                if(resp.error){
                    const errors = Object.entries(resp.error);
                    errors.forEach(([field, error]) => {
                        $(`#${field}`).after(`<label class="error" id="error_${field}">${error}</label>`);
                    });
                }else if(resp.code){
                    let type = resp.type;
                    if(type=='ICS'){
                        $('#code').html(`${resp.code}`);
                        $('#barcode').hide();
                        $('#confirmation_title').html("we've got your code!");
                        $('#step_one_instruction').html("Use this code or check your email for a copy. If you don't see it, double check your spam folder!");
                        $('#step_two_instruction').html("Head to your selected Zips, where you'll enter your code to redeem your T-Mobile Tuesday offer.");
                    }else{
                        $('#code').html(`${resp.code}`);
                        $('#barcode').html(`*$P${resp.code}*`);
                        //$('#code').removeClass('ics').addClass('barcode');
                        $('#confirmation_title').html("we've got your barcode!");
                        $('#step_one_instruction').html("Use this barcode or check your email for a copy. If you don't see it, double check your spam folder!");
                        $('#step_two_instruction').html("Head to your selected Zips, where you'll scan your barcode to redeem your T-Mobile Tuesday offer.");
                    }   
                        
                    $('#divForm').addClass('hidden');
                    $('.steps').addClass('hidden');
                    $('.confirmation').removeClass('hidden');
                }else{
                    $('.steps').addClass('hidden');
                    $('#message').html(`${resp.message}`);
                    $('#message').removeClass('hidden');
                }
                $('#redeem').attr('disabled',false);
                $('#redeem').html('Redeem');
                $("html, body").animate({ scrollTop: 0 }, "slow");
            }
        });
    });

    // mobile  find location button
    $('.js-location-btn').each(function(){
        /*
        $(this).click(function(e){
            console.log('Click');
            e.preventDefault();
            const service = 'ajax/functions.php';
            $('.loading-block').addClass('open');
            
            navigator.geolocation.getCurrentPosition((position) => {
                console.log(position.coords);
                let formData = new FormData(),
                    lat = position.coords.latitude,//
                    long = position.coords.longitude;//
                    formData.append('operation','getZipcodeByGeoLocation');
                    formData.append("lat",lat.toFixed(4));
                    formData.append("long",long.toFixed(4));
                    console.log(lat.toFixed(4),long.toFixed(4))
                let requestOptions = {
                        method: 'POST',
                        body: formData
                    };
                fetch(`${site_url}${service}`, requestOptions)
                .then(response => response.json())
                .then( (response) => {
                    console.log('response',response)
                    if(response.location.length>0)
                        window.location.href=`/drive-through-car-wash-locations?code=${response.location}`;
                    else
                        window.location.href=`/drive-through-car-wash-locations?noresults`;
                });
            },function(){
                window.location.href=`/drive-through-car-wash-locations?noresults`;
            },{timeout: 15000});
        })
        */
    });

    if (document.querySelectorAll("#privary-navigation .privary-navigation__item")) {
        let navPrimaryItems = document.querySelectorAll("#privary-navigation .privary-navigation__item");
        navPrimaryItems.forEach(e => {
            let links = e.querySelectorAll("a");
            links.forEach(link => {
                if (link.getAttribute("href") === "" || link.getAttribute("href") === "#") {
                    link.addEventListener("click", function(event) {
                        event.preventDefault();
                    });
                }
            });
        });
    }

    if( window.location.hash ) {
        
        setTimeout(()=>{
           
            const hash = window.location.hash.substring(1);
            const targetElement = document.getElementById(hash);
            console.log({ targetElement });
            
            
            if (targetElement) {
                targetElement.scrollIntoView({ behavior: 'smooth' }); 
            }
        
       },2000)
            
    }

	// if (document.getElementById('form_id-4121')) {
	// 	const apiUrl = 'https://uwcapp.zipscarwash.com/api/corporate-partners/lead';
	
	// 	const discountForm = document.getElementById('form_id-4121');
		
	// 	discountForm.addEventListener('submit', function (event) {
		
	// 		const formData = new FormData(discountForm);
	// 		const formData2 = new FormData();
			
	// 		const formDataValues = {
	// 			"first_name": "first_name",
	// 			"last_name": "last_name", 
	// 			"email_address": "email", 
	// 			"phone_number": "phone", 
	// 			"company_name": "company",
	// 			"zip_code": "zipcode", 
	// 			"i_agree": "privacy_policy",
	// 			"subscribe": "subscribe",
    //             "privacy_policy": "true",
    //             "subscribe": "true"
	// 		}
	// 		for (const key in formDataValues) {
	// 			const value = formDataValues[key];
	// 			for (const [keyForm, valueForm] of formData) {
	// 				if (keyForm === key) {
	// 					if (keyForm == "i_agree" || keyForm == "subscribe"  ) {
	// 						formData2.append(value, (valueForm == "y" ? 1 : 0 ) )
    //                         break;
	// 					} else{
	// 						formData2.append(value, valueForm)						
	// 					}
	// 				}
	// 			}
	// 		}

	// 		const requestOptions = {
	// 			method: 'POST',
	// 			body: formData2,
	// 			headers: {
	// 					'Authorization': apiKey
	// 				},
	// 		};
			
	// 		fetch(apiUrl, requestOptions)
	// 			.then(response => {
	// 				if (!response.ok) {
	// 					throw new Error('Network response was not ok');
	// 				}
	// 				return response.json();
	// 			})
	// 			.then((data) => {
	// 				data.message;
	// 			})
	// 			.catch(error => {
	// 			console.error('Error:', error);
	// 			});				
	// 		event.preventDefault();
	// 	});
	// }

})();

function searchCarWash(e){
    e.preventDefault()
    const zipcode = $('#zipcode').val();
    document.querySelector('.uwc-block__package-price').classList.add("hidden");
    let zipCodesRedirect = "60440,60638,60707,60164,60181,60172,60188,60172,60505,60490,60540,83713,83646,83301,84047,84095";
    $.post(site_url + 'ajax/search.php',{operation:'searchCarWash',zipcode:zipcode}, function(resp){
        
        $('.result_empty').fadeOut(400);
        if(resp.result=='success'){
            const tier = (resp.elements != null)?resp.elements.tier:null;
            console.log( zipCodesRedirect.indexOf( zipcode ) );
            if( (resp.elements != null && (tier != null ) ) && zipCodesRedirect.indexOf( zipcode ) == "-1" ){
                document.querySelector('.uwc-block__package-price').classList.remove("hidden");
                    let ua = window.navigator.userAgent.toLowerCase();

                    if( ua.indexOf( "mobile" ) == "-1" ){
                        $('#valSingle1').html(`$ ${tier.sw_4}`);
                        $('#valSingle2').html(`$ ${tier.sw_3}`);
                        $('#valSingle3').html(`$ ${tier.sw_2}`);
                        $('#valUnlimit1').html(`$ ${tier.uwc_4}`);
                        $('#valUnlimit2').html(`$ ${tier.uwc_3}`);
                        $('#valUnlimit3').html(`$ ${tier.uwc_2}`);
                    }else{
                        setTimeout( () => {
                            $('#valSingle1').html(`$ ${tier.sw_4}`);
                            $('#valSingle2').html(`$ ${tier.sw_3}`);
                            $('#valSingle3').html(`$ ${tier.sw_2}`);
                            $('#valUnlimit1').html(`$ ${tier.uwc_4}`);
                            $('#valUnlimit2').html(`$ ${tier.uwc_3}`);
                            $('#valUnlimit3').html(`$ ${tier.uwc_2}`);
                        }, 1000 )

                    }    

                    $('.uwc-block__package-price').fadeIn(400);
                if(tier.tax == 1) {
                    $('.uwc-block__package-tax').show();
                } else {
                    $('.uwc-block__package-tax').hide();
                }
                if($('.uwc-block__package-price').parents('.uwc-block .slick-list.draggable')[0] != undefined)
                    $('.uwc-block__package-price').parents('.uwc-block .slick-list.draggable').css("height","600px")
            }else{
                //$('.result_empty').fadeIn(400);
                window.location.href="/drive-through-car-wash-locations?code=" + zipcode + "&distance=60";
            }   
        }else{
        }

    },'json');
}

function updateZipCodes(){
    //console.log('Start Process');
    
    let formData = new FormData();
    formData.append('operation','getZipCodesChatmeter');
    
    let requestOptions = { method : 'POST', body : formData}
    fetch(`${site_url}ajax/functions.php`,requestOptions).then(response => response.json()).then(result => console.log(result)).catch(error => console.log('error', error));

    //console.log('End Process');
}